import React from "react";
import PropTypes from "prop-types";

import { Form } from "..";

export function FormNumber({
  id,
  name,
  description,
  value,
  required,
  errorMessage,
  disabled,
}) {
  return (
    <Form.Input
      name={id}
      label={name}
      description={description}
      defaultValue={value}
      type="number"
      fluid
      data-test="form-number"
      placeholder="Enter a number"
      required={required}
      errorMessage={errorMessage}
      disabled={disabled}
    />
  );
}

FormNumber.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
};

FormNumber.defaultProps = {
  description: "",
  value: undefined,
  required: true,
  errorMessage: "Please enter a number",
  disabled: false,
};

export default FormNumber;
